let GOOGLE_API_KEY = "";
let GOOGLE_CLIENT_ID = "";
let ENV = "staging";

export const GOOGLE_DISCOVERY_CALENDAR =
    "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest";

export const GOOGLE_API_SCOPES =
    "https://www.googleapis.com/auth/calendar.readonly";

try {
    ENV = process.env.PREACT_APP_ENV || "";

    if (!["production", "staging", "nightly", "feature"].includes(ENV)) {
        ENV = "production";
    }

    GOOGLE_API_KEY = process.env.PREACT_APP_GOOGLE_API_KEY || "";
    GOOGLE_CLIENT_ID = process.env.PREACT_APP_GOOGLE_CLIENT_ID || "";
} catch (error: unknown) {
    console.warn(
        "Pay attention: some of required environment variables are missing",
    );
}

export const getGradientEnvPostfix = () => {
    if (ENV === "production") {
        return "";
    }

    return `-${ENV}`;
};

export { ENV, GOOGLE_API_KEY, GOOGLE_CLIENT_ID };
